import axios from "axios";
import {Link} from 'react-router-dom';
import React, {useState} from "react";
import api from "../api";
import { CheckCircle, Eye, EyeOff } from "react-feather";
function CustomerRegister(props){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formError,setFormError]=useState(false);
    const [errorMsg,seterrorMsg]=useState('');
    const [successMsg,setsuccessMsg]=useState('');
    const [loading, setLoading] = useState(false);
    const [ShowEmail, setShowEmail] = useState(false);
    const [ShowSuccessPage, setShowSuccessPage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [UnameError,setUnameError]=useState(false);
    const [emailError, setEmailError] = useState('');
    const [PasswordError,setPasswordError]=useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [registerFormData, setRegisterFormData]=useState({
        "username":'',
        "email":'',
        "mobile":'',
        "password":'',
    });

    const inputHandler =(event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
    };

    const submitHandler =(event) => {
        setLoading(true);
        setShowEmail(true);
        const formData=new FormData();
            formData.append('username',registerFormData.username.toLowerCase());
            formData.append('email',registerFormData.email);
            //formData.append('mobile',registerFormData.mobile);
            formData.append('password',registerFormData.password);

            //SUBMIT DATA
            axios.post(baseUrl+'/customer/register/',formData)
            .then(function (response){
                if(response.data.bool==false){                    
                    seterrorMsg(response.data.msg)
                    setsuccessMsg('');
                }else{
                    setRegisterFormData({
                        "username":'',
                        "email":'',
                        "mobile":'',
                        "password":'',
                    });
                    seterrorMsg('');setLoading(false);
                    setShowEmail(false);
                    setShowSuccessPage(true);
                    setsuccessMsg(response.data.msg);
                }
            })
            .catch(function(error){
                seterrorMsg(error.response?.data?.msg || "An error occurred. Please try again.");
                setLoading(false);setShowEmail(false);
            });
    };

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailPattern.test(email)) {
            setEmailError('Invalid email format. Kindly enter a valid email.');
        } else {
            setEmailError('');
        }
    };
    
    const sendVerificationCode = () => {
        if(registerFormData.username.length < 2){
            setUnameError(true); 
            return;
        } else {
            setUnameError(false);
        }
        
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(registerFormData.email !== '' && !emailPattern.test(registerFormData.email)){
            setEmailError(true); 
            return;
        } else {
            setEmailError(false);
        }

        if(registerFormData.password.length < 7){
            setPasswordError(true); 
            return;
        } else {
            setPasswordError(false);
        }
        setLoading(true);
        api.post(baseUrl + "/send-verification-email/", { email: registerFormData.email,username: registerFormData.username })
            .then((response) => {
                if (response.data.success === true) {
                    setLoading(false);
                    setErrorMessage('');
                    seterrorMsg('');
                    setsuccessMsg('');
                    setShowEmail(true);
                } else {
                    seterrorMsg(response.data.message);                    
                    setShowEmail(false);
                    setLoading(false);
                }
            })
            .catch(setShowEmail(false));
    };

    const verifyCode = () => {
        if(registerFormData.email_code.length < 3){
            seterrorMsg(true); 
            return;
        } else {
            seterrorMsg(false);
        }
        
        api.post(baseUrl + "/verify-email-code/", { email: registerFormData.email, code: registerFormData.email_code })
            .then((response) => {
                if (response.data.success === true) {
                    setShowEmail(true);
                    submitHandler(); // Call the registration function
                } else {
                    seterrorMsg(response.data.message);
                }
            })
            .catch((error) => seterrorMsg(error.response?.data?.message || "An error occurred."));
    };
    const retry = () => {
        window.location.href = '/customer/register';
    };
    return (
        <section className="container mtopcon normal-mt-sctn">
            <div className="row">
                <div className="col-12 col-lg-4 reglogincon">
                    <div className="card shadow-none">
                        <div className="card-body"> 
                            {ShowSuccessPage == false && <><h2 className='mb-3 text-center'><b>Create an account</b></h2></>}                  
                            <form>
                                
                                {ShowEmail == false &&  ShowSuccessPage == false && <>
                                    <div className="mb-3">
                                        <label htmlFor="lnm" className="form-label font9 grey-text mb-0">Name*</label>
                                        <input type="text" name="username" onChange={inputHandler} value={registerFormData.username} className="form-control font9" id="lnm"/>
                                        {UnameError && <small className="text-danger font8">Confirm Name.</small>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="InputMobile" className="form-label font9 grey-text mb-0">Email*</label>
                                        <input 
                                            type="email" 
                                            name="email" 
                                            placeholder="abc@gmail.com" 
                                            onChange={inputHandler} 
                                            onBlur={(e) => validateEmail(e.target.value)} 
                                            value={registerFormData.email} 
                                            className="form-control font9" 
                                            id="InputEmail" 
                                            aria-describedby="emailHelp" 
                                        />
                                        {emailError && <small className="text-danger font8">{emailError}</small>}
                                    </div>
                                    <div className="row mb-3 display-none">
                                        <div className="col-12">
                                            <label htmlFor="InputMobile" className="form-label font9 grey-text mb-0">Phone No.</label>
                                            <input type="number" name="mobile" placeholder="254724000000" onChange={inputHandler} value={registerFormData.mobile} className="form-control font9" id="InputMobile" aria-describedby="emailHelp" />
                                        </div>
                                    </div>
                                    <div className="mb-3 position-relative">
                                        <label htmlFor="InputPassword1" className="form-label font9 grey-text mb-0">Password*</label>
                                        <div className="input-group">
                                            <input 
                                                type={showPassword ? "text" : "password"} 
                                                name="password" 
                                                placeholder="At least 7 characters" 
                                                onChange={inputHandler} 
                                                value={registerFormData.password} 
                                                className="form-control font9 br-0" 
                                                id="InputPassword1" 
                                            />
                                            <button 
                                                type="button" 
                                                className="btn btn-outline-grey bl-0" 
                                                onClick={() => setShowPassword(!showPassword)}
                                                tabIndex={-1}
                                            >
                                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                            </button>
                                        </div>
                                        {PasswordError && <small className="text-danger font8">Kindly use at least 7 characters.</small>}
                                    </div>       
                                    {errorMsg && <p className="text-danger text-center mt-3 mb-3"><b>{errorMsg}</b></p> }                       
                                    <button type="button" onClick={sendVerificationCode} className="col-12 btn btn-dark mt-2 big-btn">{ loading === true ? <>Loading...</> : <>Continue</>}</button>                           
                                    <div className="mb-3 mt-4 text-center">
                                        <p className='f85'>We value your privacy, by Proceeding you agree to our <Link to="/terms" className="grey-text font-bold">Terms & Conditions</Link> and <Link to="/privacy" className="grey-text font-bold">Privacy Policy</Link></p>
                                    </div>
                                    <div className="mb-3 font9 text-center">
                                        <p className='f85'>Already have an account? <Link to="/customer/login" className="grey-text font-bold">Log in</Link></p>
                                    </div>
                                </>}
                                {ShowEmail == false && ShowSuccessPage == true && <>
                                        <div className="row text-center mt-4">
                                            <div className="col-md-12 mb-2">
                                                <div className="btn btn-outline-success border-0"><CheckCircle width='100px' height='100px' /></div>
                                            </div>
                                            <div className="col-12">
                                                <h2 className='mb-3 text-center'><b>Success</b></h2>
                                                <p className='grey-text mb-4'>Congratulations, your account has been successfully created.</p>
                                                <Link to="/customer/login" className="btn btn-success br-18 border-0">Proceed to Sign in</Link>
                                            </div>
                                        </div>
                                </>}
                                {ShowEmail == true && <>
                                    <div className="mt-4 mb-4 border p-4 br-10">
                                        {successMsg && <p className="text-success text-center mb-3 font9 mb-0"><b>{successMsg}</b></p> } 
                                        {errorMsg && <p className="text-danger text-center mb-3 font9 mb-0"><b>{errorMsg}</b></p> } 
                                        <label htmlFor="InputPassword1" className="form-label font9 dark-text mb-0"><b>Email Code</b></label>
                                        <label htmlFor="InputPassword1" className="form-label font8 grey-text mb-3">Kindly enter code sent to <u>{registerFormData.email}</u> to complete.</label>
                                        <input type="number" name="email_code" onChange={inputHandler} value={registerFormData.email_code} placeholder='- - - - - -' className="form-control font9" id="InputPassword1"/>
                                        <div onClick={sendVerificationCode} className='font9 mt-3 text-blue'>Resend</div>
                                        <button type="button" onClick={verifyCode} className="col-12 btn btn-dark mt-3 big-btn">{ loading === true ? <>Loading...</> : <>Complete</>}</button>  
                                    </div>
                                </>}

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CustomerRegister;